import { render, staticRenderFns } from "./troubles.vue?vue&type=template&id=05657b52&scoped=true"
import script from "./troubles.vue?vue&type=script&lang=js"
export * from "./troubles.vue?vue&type=script&lang=js"
import style0 from "./troubles.vue?vue&type=style&index=0&id=05657b52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05657b52",
  null
  
)

export default component.exports